export default __webpack_public_path__ + "static/media/bg-valdano-bio-02@3x.68acea46.jpg";